import { render, staticRenderFns } from "./116.vue?vue&type=template&id=66cb136e&scoped=true&"
var script = {}
import style0 from "./116.vue?vue&type=style&index=0&id=66cb136e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cb136e",
  null
  
)

export default component.exports